import React, { Component } from 'react';
import { Table } from 'react-bootstrap'
import Api from './../../../Global/Modules/Api'
const FETCH_URL = "api/workingexperiences/referencedetail/"
class WerkervaringReferentieDetail extends Component {
    constructor() {
        super();
        this.handleClickVerk = this.handleClickVerk.bind(this)
        this.state = {
            details: {}
        }
    }
    componentWillMount() {
        Api.GetApi(FETCH_URL + this.props.match.params.ref + "/" + this.props.match.params.id).then(data => {
            this.setState({ details: data });
        })
    }
    handleClickVerk(e) {
        var url = "api/members/" + e + "/getWerk";
        Api.GetApiDownload(url)
    }
    render() {
        return (
            <div>
                <h3>Details</h3>
                <Table responsive striped bordered className="refTable">
                    <tr><td>Aanvrager</td><td>{this.state.details.member}</td></tr>
                    <tr><td>Werkgever</td><td>{this.state.details.company}</td></tr>
                    <tr><td>Niveau</td><td>{this.state.details.level}</td></tr>
                    <tr><td>Uitgevoerd voor</td><td>{this.state.details.customer}</td></tr>
                    <tr><td>Soort project</td><td>{this.state.details.projectType}</td></tr>
                    <tr><td>Project</td><td>{this.state.details.project}</td></tr>
                    <tr><td>Locatie</td><td>{this.state.details.city}</td></tr>
                    <tr><td>Jaar</td><td>{this.state.details.yearFrom}<br />{this.state.details.yearTo}</td></tr>
                    <tr><td>Uren</td><td>{this.state.details.hours}</td></tr>
                    <tr><td>Omschrijving project</td><td>{this.state.details.projectDescription}</td></tr>
                    <tr><td>Omschrijving werkzaamheden</td><td>{this.state.details.jobDescription}</td></tr>
                    {this.state.details.file ? <tr><td>Toegevoegd document</td><td><a onClick={() => this.handleClickVerk(this.props.match.params.id)} target="_blank" title={"Bekijk document"}>document<br /></a></td></tr> : ""}
                </Table>

                <a href={"/referenten/index/" + this.props.match.params.ref}>Terug naar overzicht</a>
            </div>
        )
    }
}

export default WerkervaringReferentieDetail


// WEBPACK FOOTER //
// ./src/components/Member/Pages/Werkervaring/WerkervaringReferentieDetail.js